// @flow
import React from 'react'
import { Stink } from 'components/Stink'
import styled from 'styled-components'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import './styles.scss'

export class Section5 extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
    }
    this.updateSizes = this.updateSizes.bind(this)
  }

  updateSizes() {
    this.setState({
      isMobile: window.innerWidth < 711
    })
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateSizes)
    this.updateSizes()
  }

  render() {
    return <div className='section five'>
       <div className="wrapper">
        <h2>Voici les noms les plus populaires</h2>
        <div className='two-column'>
            <div className={'column left'} key={'left'}>
              <div className='txt'>
                Lorsqu'il s'agit de trouver un nom pour leur chien, les Suisses et Suissesses font preuve de créativité. La majorité des noms n'apparaissent qu'une seule fois et ne sont donc pas enregistrés dans les statistiques. Les animaux sans nom (cela existe) ou ceux avec des désignations «techniques» (par exemple des chiffres) ne sont pas pris en compte ici. Certains noms sont néanmoins très fréquents.
              </div>
              <div className="chart">
                <AutofitIFrame
                  src={'https://datawrapper.dwcdn.net/zj7CI/' + '?dark=' + String(this.props.colorMode === 'dark')}
                />
              </div>
            </div>

            <div className={'column right'} key={'right'}>
              <div className='txt'>
                Chez les femelles, «Luna» se révèle être de loin le nom le plus populaire, suivi de «Kira» et «Nala». Étonnant: tous les noms de ce top 10 se retrouvent également dans la liste des noms de filles les plus populaires. Ce n'est pourtant que rarement le cas pour les mâles. Ici, les noms les plus populaires rappellent plutôt des personnages de films ou de bandes dessinées.
              </div>
              <div className="chart">
                <AutofitIFrame
                  src={'https://datawrapper.dwcdn.net/vuViV/1/' + '?dark=' + String(this.props.colorMode === 'dark')}
                />
              </div>
            </div>
        </div>
      </div>
    </div>
  }
}
